import { createSlice } from '@reduxjs/toolkit'

interface ImportState {
    importedFile: any,
    importedFileVisibility: boolean
}

const initialState: ImportState = {
    importedFile: null,
    importedFileVisibility: false
}

export const importSlice = createSlice({
    name: 'import',
    initialState,
    reducers: {
        setImportedFile: (state: ImportState, action) => {
            state.importedFile = action.payload;
        },
        setImportedFileVisibility: (state: ImportState, action) => {
            state.importedFileVisibility = action.payload;
        },

    }
})

export const { setImportedFile, setImportedFileVisibility } = importSlice.actions;

export default importSlice.reducer;